/**
 * Created by Colin.Watson on 4/9/2015.
 */
(function () {
	'use strict';

	angular
		.module('app.core')
		.constant('toastr', toastr)
		.constant('moment', moment)
		.constant('_', _);
})();
